import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TagComponent } from './tag.component.js';
import { AppFlexModule } from '../flex/index.js';
import { IconModule } from '../icons/index.js';
import { TagListComponent } from './tag-list.component.js';
import { TypographyModule } from 'lib/typography/index.js';

@NgModule({
	imports: [CommonModule, AppFlexModule, IconModule, TypographyModule],
	declarations: [TagComponent, TagListComponent],
	exports: [TagComponent, TagListComponent]
})
export class TagModule {}
